// extracted by mini-css-extract-plugin
export default {"badge":"StoreBadge_badge__rseCq"};